import React, { useState } from "react";

const SaveButton = () => {
  const [saved, setSaved] = useState(false);

  const toggleSave = () => {
    setSaved((prev) => !prev);
  };

  return (
    <div
      className={`save-icon ${saved ? "saved" : ""}`}
      onClick={toggleSave}
    >
      {saved ? "Сохранено" : "Сохранить"}
    </div>
  );
};

export default SaveButton;
